// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__e_voj","modalFooterButton":"ModalNotes_modalFooterButton__1pElZ"};